import React from "react";
import { Link } from "react-router-dom";
import tykonlogo from "../../assets/Tykoon Sports 1.png";

const SigninWrapper = ({ headingText, children }) => {
  return (
    <>
      <section className="bg-gray-50 w-full h-screen">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto md:h-screen lg:py-0">
          <Link
            to={"/"}
            className="flex items-center mb-6 text-2xl font-semibold text-gray-900 "
          >
            <img
              className="w-full h-20 mr-2 object-cover"
              src={tykonlogo}
              alt="logo "
            />
          </Link>
          <div className="w-full bg-white rounded-lg shadow md:mt-0 sm:max-w-lg xl:p-0 ">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-gray-900 md:text-2xl">
                {headingText}
              </h1>
              {/* <form className="space-y-4 md:space-y-6" >
                                <div>
                                    <label
                                        htmlFor="email"
                                        className="block mb-2 text-sm font-medium text-gray-900 "
                                    >
                                        Your email
                                    </label>
                                    <input
                                        type="email"
                                        name="email"
                                        id="email"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5"
                                        placeholder="name@company.com"
                                        required=""
                                    />
                                </div>
                                <div>
                                    <label
                                        htmlFor="password"
                                        className="block mb-2 text-sm font-medium text-gray-900 "
                                    >
                                        Password
                                    </label>
                                    <input
                                        type="password"
                                        name="password"
                                        id="password"
                                        placeholder="••••••••"
                                        className="bg-gray-50 border border-gray-300 text-gray-900 rounded-lg block w-full p-2.5"
                                        required=""
                                    />
                                </div>
                                <div className="flex items-center justify-between">
                                    <Link
                                        to={'/'}
                                        className="text-sm font-medium text-primary-600 hover:underline "
                                    >
                                        Forgot password?
                                    </Link>
                                </div>
                                <Button type={'Signin'}/>
                            </form> */}
              {children}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default SigninWrapper;
